import React, { useState } from "react";
import { getPageStyles } from "../../SiteManagement/styles"; //TODO export these further up!
import { Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface PagingProps {
  totalPages: number;
  filteredResultsLength: number;
  setPage: (page: number) => void;
}

export default function Paging({
  filteredResultsLength,
  totalPages,
  setPage,
}: PagingProps) {
  const theme = useTheme();
  const styles = getPageStyles(theme);

  const [currentPage, setCurrentPage] = useState(0);

  const navigate = (direction: "first" | "prev" | "next" | "last") => {
    const newPage = (() => {
      switch (direction) {
        case "first":
          return 0;
        case "prev":
          return currentPage - 1;
        case "next":
          return currentPage + 1;
        case "last":
          return totalPages - 1;
        default:
          return 0;
      }
    })();

    setCurrentPage(newPage);
    setPage(newPage);
  };

  if (!filteredResultsLength && !totalPages) {
    return <></>
  }

  if (filteredResultsLength) {
    return <em>Displaying up to 500 search results</em>;
  }

  if (totalPages === 1) {
    return (
      <Box sx={styles.pageControls}>
        <em>Displaying page 1 of 1 | Records 1-100</em>
      </Box>
    );
  }

  return (
    <Box sx={styles.pageControls}>
      <em>
        Displaying page {currentPage + 1} of {totalPages}
      </em>{" "}
      &nbsp;&nbsp;&nbsp;&nbsp;
      {currentPage > 0 && (
        <Button onClick={() => navigate("prev")}>{"Prev"}</Button>
      )}
      <span>
        {currentPage * 100 + 1} - {currentPage * 100 + 100}
      </span>
      &nbsp;&nbsp;
      {currentPage + 1 < totalPages && (
        <Button onClick={() => navigate("next")}>{"Next"}</Button>
      )}
      <em>Toolbox: </em>
      {currentPage > 0 && (
        <Button
          onClick={() => {
            navigate("first");
          }}
        >
          {"First page"}
        </Button>
      )}
      {currentPage !== totalPages - 1 && (
        <Button
          onClick={() => {
            navigate("last");
          }}
        >
          {"Last page"}
        </Button>
      )}
    </Box>
  );
}
